export default "__VITE_ASSET__DvQLiQwy__"